import { render, staticRenderFns } from "./customerMessage.vue?vue&type=template&id=6e3f7a66&scoped=true&"
import script from "./customerMessage.vue?vue&type=script&lang=js&"
export * from "./customerMessage.vue?vue&type=script&lang=js&"
import style0 from "./customerMessage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./customerMessage.vue?vue&type=style&index=1&id=6e3f7a66&scoped=true&lang=less&"
import style2 from "./customerMessage.vue?vue&type=style&index=2&lang=less&"
import style3 from "./customerMessage.vue?vue&type=style&index=3&id=6e3f7a66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f7a66",
  null
  
)

export default component.exports